import { useState } from "react";
import { SEO } from "@/components/SEO";

export default function LandingPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      // For now, just show confirmation. Can wire to a backend later.
      setSubmitted(true);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
      <SEO
        title="Prozpector - Coming Soon"
        description="Outbound automation for B2B sales teams. Currently in private beta."
        url="https://prozpector.com"
      />

      <div className="max-w-md w-full text-center">
        <img
          src="/logo-wordmark-dark.svg"
          alt="Prozpector"
          className="h-10 mx-auto mb-12"
        />

        <h1 className="text-4xl font-bold tracking-tight text-black mb-4">
          Coming Soon
        </h1>

        <p className="text-lg text-gray-600 mb-10">
          Outbound automation for B2B sales teams.
          <br />
          We're currently in private beta.
        </p>

        {submitted ? (
          <p className="text-green-600 font-medium">
            Thanks. We'll be in touch.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="flex gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
              className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-sm"
            />
            <button
              type="submit"
              className="px-5 py-3 bg-primary text-white rounded-lg font-medium text-sm hover:bg-primary/90 transition-colors whitespace-nowrap"
            >
              Notify Me
            </button>
          </form>
        )}

        <p className="text-sm text-gray-400 mt-10">
          Questions? <a href="https://www.linkedin.com/in/scottdudley/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Connect on LinkedIn</a>
        </p>
      </div>
    </div>
  );
}
